import { nodeType } from './nodeType';

export const isEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};
export const compareWorkflows = (dataById, workflowData) => {
  const cleanNodes = (nodes) =>
    nodes?.map(
      ({
        position,
        type,
        measured,
        message,
        question,
        form,
        media,
        carousel,
        capture,
        responseAi,
        workFlowNode_Condition,
        createWorkFlow_Intents,
        redirectNode,
        selected,
        suggestedQuestions,
        ...node
      }) => ({
        ...node,
        position: { x: node.positionX, y: node.positionY },
        type: nodeType(node.nodeType),
        id: node.nId?.toString(),
        is_Error: node.is_Error || false,
        title: 'test',
      })
    );
  const cleanEdges = (edges) =>
    edges?.map(({ type, style, markerEnd, source, target, ...edge }) => ({
      ...edge,
      source: source?.toString(),
      target: target?.toString(),
    }));

  const nodes1 = cleanNodes(dataById?.nodes);
  const nodes2 = cleanNodes(workflowData?.nodes);

  if (JSON.stringify(nodes1) !== JSON.stringify(nodes2)) return false;

  const edges1 = cleanEdges(dataById?.edges);
  const edges2 = cleanEdges(workflowData?.edges);

  if (JSON.stringify(edges1) !== JSON.stringify(edges2)) return false;

  return true;
};
